import styled, { keyframes } from "styled-components";
import { Button } from "antd";

export const ModalContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  gap: 32px;
  padding: 12px 8px 0;
  min-height: 400px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ColumnTitle = styled.h3`
  font-weight: 700;
  font-size: 16px;
  color: #333;
  margin: 0 0 20px 0;
  text-align: center;
`;

export const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 16px;
  padding: 0 8px;

  .ant-input {
    min-width: 0;
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #666;
  margin-bottom: 4px;

  &.required {
    color: #f21167;
  }
`;

export const FieldError = styled.div`
  font-size: 12px;
  color: #cf1322;
  margin-top: 4px;
`;

export const FieldInfo = styled.div`
  font-size: 12px;
  color: #1f5454;
  font-weight: 600;
  margin-top: 6px;
`;

export const ToteVisual = styled.div`
  flex: 1;
  width: 80%;
  max-width: 220px;
  border: 2px solid #bbb;
  border-radius: 6px;
  background: #fafafa;
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 6px;
  margin-bottom: 12px;
`;

export const ToteInner = styled.div`
  flex: 1;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  background: #f0f0f0;
`;

export const SlotLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #555;
  text-align: center;
`;

export const BatchLabel = styled.div`
  margin-top: 8px;
  max-width: 220px;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  text-align: center;
  overflow-wrap: anywhere;
`;

/* Tote drop animation keyframes */
const toteDrop = keyframes`
  0% {
    top: -56px;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  65% {
    top: calc(100% - 56px);
  }
  80% {
    top: calc(100% - 64px);
  }
  92% {
    top: calc(100% - 54px);
  }
  100% {
    top: calc(100% - 56px);
  }
`;

export const PlacementContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const SlotVisual = styled.div`
  width: 80%;
  max-width: 220px;
  height: 220px;
  border: 2px dashed #aaa;
  border-radius: 6px;
  background: #fafafa;
  position: relative;
  overflow: hidden;
  margin-bottom: 12px;
`;

export const ToteDropElement = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -56px;
  width: 65%;
  height: 44px;
  background: #1f5454;
  color: white;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  opacity: 0;
  z-index: 2;

  &.animate {
    animation: ${toteDrop} 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      infinite;
  }
`;

export const HighlightZone = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: #e8e8e8;
  border-top: 1px dashed #ccc;
`;

export const PlacementText = styled.p`
  font-size: 13px;
  color: #666;
  text-align: center;
  margin: 0 0 16px 0;
`;

export const DoneButton = styled(Button)`
  && {
    width: 70%;
    height: 44px;
    border-radius: 22px;
    font-weight: 700;
    font-size: 15px;
    background: ${(props) =>
      props.disabled ? "#cccccc" : "#1f5454"};
    border: none;
    color: #fff;
    box-shadow: ${(props) =>
      props.disabled ? "none" : "0 2px 6px rgba(31, 84, 84, 0.3)"};

    &:hover:not(:disabled) {
      background: #2a6f6f !important;
      color: #fff !important;
    }

    &:active:not(:disabled) {
      background: #164242 !important;
    }

    &:disabled {
      color: #fff !important;
      cursor: not-allowed;
    }
  }
`;

export const ErrorText = styled.div`
  width: 90%;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  color: #cf1322;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
`;

export const RemainderOrderPanel = styled.div`
  width: 90%;
  padding: 10px 12px;
  margin-bottom: 12px;
  border: 1px solid #b7d5d5;
  border-radius: 6px;
  background: #f4fbfb;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const RemainderText = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.35;
  color: #1f5454;
  text-align: center;
`;

export const CreateOrderButton = styled(Button)`
  && {
    width: 100%;
    min-height: 36px;
    border-radius: 6px;
    font-weight: 700;
    background: ${(props) =>
      props.disabled ? "#cccccc" : "#ffffff"};
    border: 1px solid ${(props) =>
      props.disabled ? "#cccccc" : "#1f5454"};
    color: ${(props) =>
      props.disabled ? "#ffffff" : "#1f5454"};

    &:hover:not(:disabled) {
      background: #e9f5f5 !important;
      border-color: #2a6f6f !important;
      color: #1f5454 !important;
    }

    &:disabled {
      color: #fff !important;
      cursor: not-allowed;
    }
  }
`;

export const SuccessText = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #237804;
  text-align: center;
`;

export const WarningText = styled.p`
  font-size: 11px;
  color: #f21167;
  text-align: center;
  margin: 10px 0 0 0;
`;
